import React from "react";

declare global {
  interface Window {
    Turbo?: {
      visit: (url: string) => void;
    };
  }
}

// Shim for react-router-dom Link component
// Uses regular <a> tags with Turbo navigation
export function Link({
  to,
  children,
  className,
  ...props
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
  [key: string]: unknown;
}) {
  return (
    <a href={to} className={className} data-turbo="true" {...props}>
      {children}
    </a>
  );
}

// Shim for useNavigate - uses Turbo.visit or window.location
export function useNavigate() {
  return (path: string) => {
    if (window.Turbo) {
      window.Turbo.visit(path);
    } else {
      window.location.href = path;
    }
  };
}

// Shim for useLocation
export function useLocation() {
  return {
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: null,
  };
}

// Shim for useSearchParams
export function useSearchParams(): [URLSearchParams, (params: URLSearchParams) => void] {
  const params = new URLSearchParams(window.location.search);
  const setParams = (newParams: URLSearchParams) => {
    const url = `${window.location.pathname}?${newParams.toString()}`;
    if (window.Turbo) {
      window.Turbo.visit(url);
    } else {
      window.location.href = url;
    }
  };
  return [params, setParams];
}

// Shim for useParams
export function useParams(): Record<string, string> {
  return {};
}

// Router components that just render children
export function BrowserRouter({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

export function Routes({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

export function Route({ element }: { element: React.ReactNode; path?: string }) {
  return <>{element}</>;
}

export function Outlet() {
  return null;
}
